import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-expandable',
  templateUrl: './expandable.component.html',
  styleUrls: ['./expandable.component.scss'],
})
export class ExpandableComponent implements OnInit {
  @Input('headerColor') headerColor: any = '#F53D3D';
  @Input('textColor') textColor: any = 'grey';
  @Input('contentColor') contentColor: any = '#F9F9F9';
  @Input('title') title:any;
  @Input('image') image: any;
  @Input('category') category = [];
  @Input('hasMargin') hasMargin: boolean = true;
  @Input('expanded') expanded:any;
  @Input('subcategory') subcategory: any;
  @ViewChild('accordionContent', { static: true }) elementView:any= ElementRef;
  viewHeight:any;
  url;
  constructor(public DBservice: DataService,public renderer: Renderer2) {
      this.url = this.DBservice.domainUrl;

   }

  ngOnInit() {
    console.log(this.expanded)
  }

  ngAfterViewInit() {
    this.viewHeight = this.elementView.nativeElement.offsetHeight;

    if (!this.expanded) {
      this.renderer.setStyle(this.elementView.nativeElement, 'height', 0 + 'px');
    }
  }

  toggleAccordion(category) {
    if(category.length != 0){
    this.expanded = !this.expanded;
    const newHeight = this.expanded ? '100%' : '0px';
    this.renderer.setStyle(this.elementView.nativeElement, 'height', newHeight);}
  }

}
